/* RESON V2 - kit-offer.js
   Tier ladder for the PDP. Each tier is a pointer at a product: the page's own
   product for "just the plugs", a bundle for a kit, or ANOTHER model's bundle for
   an upgrade tier. Selecting a tier adds ONE line item - whichever product that
   tier points at - so an upgrade adds the other model's kit, not this page's.

   All prices come from the live variant data emitted by kit-offer.liquid, so the
   number on screen is the number Shopify charges. Nothing is hardcoded. */
(function () {
  function init(root) {
    if (root.dataset.kitReady === '1') return;

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-kit-config]').textContent) || {}; } catch (e) {}
    var tiers = cfg.tiers || [];
    var currency = cfg.currency || '$';
    var sym = currency.indexOf('$') >= 0 ? currency : currency + '$';
    /* Matches Liquid's money_without_trailing_zeros: A$79, but A$52.99 */
    function money(cents) {
      var n = Math.round(cents) / 100;
      return sym + (n % 1 === 0 ? String(n) : n.toFixed(2));
    }

    var addBtn = root.querySelector('[data-kit-add]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-kit-row]'));
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-kit-input]'));
    if (!addBtn || !rows.length) return;

    /* The tier that is pre-selected on load is what "+$X" is measured against */
    var baseIndex = 0;
    inputs.forEach(function (inp, i) { if (inp.checked) baseIndex = i; });

    function selectsOf(i) {
      return Array.prototype.slice.call(rows[i].querySelectorAll('[data-kit-option]'))
        .sort(function (a, b) {
          return parseInt(a.getAttribute('data-kit-option'), 10) - parseInt(b.getAttribute('data-kit-option'), 10);
        });
    }

    /* Stash original option labels once so the "- sold out" suffix never stacks */
    rows.forEach(function (row, i) {
      selectsOf(i).forEach(function (sel) {
        Array.prototype.slice.call(sel.options).forEach(function (o) {
          o.setAttribute('data-label', o.textContent);
        });
      });
    });

    function variantFor(i) {
      var t = tiers[i];
      if (!t || !t.variants || !t.variants.length) return null;
      var sels = selectsOf(i);
      if (!sels.length) return t.variants[0];
      var vals = sels.map(function (s) { return s.value; });
      for (var v = 0; v < t.variants.length; v++) {
        var cand = t.variants[v], ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (cand.o[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return cand;
      }
      return null;
    }

    /* Disable option values with no available combination, then bounce off them */
    function markAvailability(i) {
      var t = tiers[i];
      if (!t) return;
      selectsOf(i).forEach(function (sel, idx) {
        Array.prototype.slice.call(sel.options).forEach(function (o) {
          var any = t.variants.some(function (v) { return v.o[idx] === o.value && v.a; });
          var label = o.getAttribute('data-label') || o.value;
          o.disabled = !any;
          o.textContent = any ? label : label + ' - sold out';
        });
        var cur = sel.options[sel.selectedIndex];
        if (cur && cur.disabled) {
          for (var k = 0; k < sel.options.length; k++) {
            if (!sel.options[k].disabled) { sel.selectedIndex = k; break; }
          }
        }
      });
    }

    function selectedIndex() {
      for (var i = 0; i < inputs.length; i++) { if (inputs[i].checked) return i; }
      return 0;
    }

    function paint(i, variant, baseVariant) {
      var row = rows[i], t = tiers[i] || {};
      var totalEl = row.querySelector('[data-kit-total]');
      var compareEl = row.querySelector('[data-kit-compare]');
      var pill = row.querySelector('[data-kit-save]');
      var note = row.querySelector('[data-kit-note]');
      var thumb = row.querySelector('[data-kit-thumb]');

      if (!variant) {
        if (totalEl) totalEl.textContent = 'Sold out';
        [compareEl, pill, note].forEach(function (el) { if (el) el.hidden = true; });
        return;
      }
      if (totalEl) totalEl.textContent = money(variant.p);
      if (thumb && variant.img) thumb.src = variant.img;

      /* "was" price: the parts basis when configured, otherwise the compare-at */
      var basis = t.basis > 0 ? t.basis : (variant.c || 0);
      var saving = basis - variant.p;

      if (compareEl) {
        var showWas = cfg.showWas !== false && saving > 0;
        compareEl.hidden = !showWas;
        if (showWas) compareEl.textContent = money(basis);
      }
      if (pill) {
        var show = saving > 0 && cfg.saveStyle && cfg.saveStyle !== 'none';
        pill.hidden = !show;
        if (show) {
          var label = cfg.saveLabel || 'Save';
          pill.textContent = cfg.saveStyle === 'percent'
            ? label + ' ' + Math.round((saving / basis) * 100) + '%'
            : label + ' ' + money(saving);
        }
      }
      if (note) {
        var txt = t.note;
        if (!txt && baseVariant && i !== baseIndex) {
          var delta = variant.p - baseVariant.p;
          if (delta > 0) txt = (cfg.noteAuto || '+') + money(delta);
        }
        note.hidden = !txt;
        if (txt) note.textContent = txt;
      }
    }

    function recompute() {
      rows.forEach(function (row, i) { markAvailability(i); });
      var baseVariant = variantFor(baseIndex);
      rows.forEach(function (row, i) { paint(i, variantFor(i), baseVariant); });

      inputs.forEach(function (inp, i) { rows[i].classList.toggle('is-selected', inp.checked); });

      var chosen = variantFor(selectedIndex());
      if (!chosen || !chosen.a) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to bag - ' + money(chosen.p);
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-kit-input], [data-kit-option]')) recompute();
    });

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var chosen = variantFor(selectedIndex());
      if (!chosen || !chosen.a) return;
      if (window.RESONCart) window.RESONCart.add([{ id: chosen.id, quantity: 1 }]);
    });

    root.dataset.kitReady = '1';
    recompute();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-kit-offer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
